import React, { useState, useEffect, useContext, useRef } from 'react';
import { Icon, Button, Upload, message } from 'antd';
import { useTranslation, withTranslation } from 'react-i18next';
import * as S from '../styles';
import { useBatchJob } from '../../../../../context/BatchJobContext';
import { getComplexDocument } from '../../../../../utils/services/complexDocumentsAPI';
import { getTagsList } from '../../../../../utils/services/mailRoomAPI';
import { checkUserAccess } from '../../../../../context/sessionContext';
import { AppStoreContext } from '../../../../../context/appStoreContext';
import { getComplexEmail } from '../../../../../utils/services/complexEmailAPI';
import { getConsolidateVariableContract } from '../../../../../utils/services/channelAPI';
import { BATCH_JOBS_DASHBOARD as trans } from '../translationValues';
import { getSampleDataSet } from '../../../../../utils/helper';
import { generateCSVHeadersFromJSON } from '../../../../../utils/helper';
import { downloadDelimitedFile } from '../../../../../utils/helper';
import {
  generateSampleExcelforBatch,
  downloadFlatFilesForBatch,
  downloadJsonForBatch,
  beforeUploadBatch,
  apiArrayToExcelforBatch,
  beforeUploadEmailTransactionBatch,
  downloadSampleFormatForBatch,
  downloadFlatFilesForEmailBatch,
  onImportFileHelper,
  downloadSampleFileForBatch,
} from '../../../../../utils/helper';
import { generateSampleExcel } from '../../../../../utils/transactionHelpers';
import { uploadDataSetTransaction } from '../../../../../utils/services/documentAPI';
import { uploadComplexEmailDataSet } from '../../../../../utils/services/complexEmailAPI';
import { uploadEnvDataSet } from '../../../../../utils/services/documentAPI';
import { createAdvancedBatch } from '../../../../../utils/services/statusMonitoringAPI';
import { getSelectedTemplate } from '../../../../../utils/services/templatesAPI';

const NAMESPACES = [
  'TRANSACTIONS',
  'EMAIL_TRANSACTIONS',
  'PDF_TRANSACTIONS',
  'FILTER_PANEL',
  'BATCH_JOBS_DASHBOARD',
];

const Step3DataUpload = () => {
  const {
    uploadedFile,
    setUploadedFile,
    showDownloadDropdown,
    setShowDownloadDropdown,
    // handleDownloadSample,
    handleFileSelect,
    fileInputRef,
    selectedLanguage,
    format,
    jobName,
    setRequestData,
    setEnvValue,
    jobType,
    requestData,
    envValue,
    batchId,
    selectedTemplate
  } = useBatchJob();
  const { t } = useTranslation(NAMESPACES);
  const [templateData, setTemplateData] = useState();
  const [tagsData, setTagsData] = useState([]);
  const isMailRoomModuleEnabled = checkUserAccess('client', ['MAILROOMADMIN', 'MAILROOMCLIENT']);
  const { globalVariables } = useContext(AppStoreContext);
  const payloadData = useRef();

  useEffect(() => {
    getTemplateData();
  }, []);

  useEffect(() => {
    getTagsData();
  }, [isMailRoomModuleEnabled]);

  const getTemplateData = async () => {
    try {
      let response;
      let payload;
      switch (format) {
        case 'PRINT':
          response = await getComplexDocument(selectedLanguage?.templateId, 'published', false);
          break;
        case 'EMAIL':
          response = await getComplexEmail(selectedLanguage?.templateId, 'published');
          break;
        case 'MULTI CHANNEL':
          payload = {
            communicationId: selectedTemplate,
          };
          response = await getConsolidateVariableContract(payload, 'live');
          break;
        default:
          break;
      }
      if(response?.data){
      setTemplateData(response?.data);
      }
    } catch (error) {
      message.error(t(trans.ERROR_FETCH_TEMPLATE_DATA.key, trans.ERROR_FETCH_TEMPLATE_DATA.value));
    }
  };

  const getTagsData = async () => {
    try {
      if (isMailRoomModuleEnabled) {
        let tagsData = await getTagsList();
        if (tagsData && tagsData?.data) {
          setTagsData(tagsData?.data);
        }
      }
    } catch (error) {
      // console.error('Error fetching tags data:', error);
    }
  };

  const handleDownloadSample = fileFormat => {
    setShowDownloadDropdown(false);
    let dataset;
    switch (fileFormat) {
      case 'Excel':
        if (format === 'PRINT') {
          generateSampleExcelforBatch(templateData, isMailRoomModuleEnabled, tagsData);
        } else if (format === 'EMAIL') {
          apiArrayToExcelforBatch(templateData);
        } else if (format === 'MULTI CHANNEL') {
          const templateDetails = {
            variableContract: templateData.variableContract,
            passwordProtected: templateData.passwordProtected,
            name: `${templateData?.communicationName}-sample`,
            env: 'live',
          };
          generateSampleExcel(templateDetails, false, isMailRoomModuleEnabled, tagsData, true, t);
        }
        break;
      case 'JSON':
      case 'XML':
        if (format === 'PRINT') {
          downloadJsonForBatch(
            fileFormat,
            templateData,
            globalVariables,
            isMailRoomModuleEnabled,
            tagsData,
          );
        } else if (format === 'EMAIL') {
          downloadSampleFormatForBatch(fileFormat, templateData, globalVariables);
        } else if (format === 'MULTI CHANNEL') {
          dataset = getSampleDataSet(
            templateData?.variableContract,
            globalVariables,
            'communication',
            'live',
            true,
          );
          downloadSampleFileForBatch(
            dataset,
            templateData,
            fileFormat.toLowerCase(),
            '',
            'live',
            t,
          );
        }
        break;
      case 'CSV':
      case 'TXT (Tab Delimited)':
      case 'TXT (Pipe Delimited)':
        const effectiveFormat = fileFormat.includes('Tab')
          ? 'tsv'
          : fileFormat.includes('Pipe')
          ? 'psv'
          : fileFormat === 'CSV'
          ? 'csv'
          : '';
        if (format === 'PRINT') {
          downloadFlatFilesForBatch(effectiveFormat, templateData, globalVariables, t);
        } else if (format === 'EMAIL') {
          downloadFlatFilesForEmailBatch(effectiveFormat, templateData, globalVariables, t);
        } else if (format === 'MULTI CHANNEL') {
          dataset = getSampleDataSet(
            templateData?.variableContract,
            globalVariables,
            'flatFile/communication',
            'live',
            true,
          );
          const headers = generateCSVHeadersFromJSON(dataset);
          const name = templateData.name;
          downloadDelimitedFile({ name, headers, format: effectiveFormat, rows: [], env: 'live' });
        }
        break;
      default:
        break;
    }
  };

  const handleUpload = async file => {
    if (format === 'PRINT') {
      await beforeUploadBatch(
        setRequestData,
        setUploadedFile,
        file,
        templateData,
        isMailRoomModuleEnabled,
        tagsData,
        jobName,
        t
      );      
      
    } else if (format === 'EMAIL') {
      await beforeUploadEmailTransactionBatch(
        setRequestData,
        setUploadedFile,
        isMailRoomModuleEnabled,
        file,
        templateData,
        jobName,
        t,
      );
    } 
    else if (format === 'MULTI CHANNEL') {
      const batchName = jobName ? jobName : templateData?.name;
      await onImportFileHelper(
        setEnvValue,
        setRequestData,
        setUploadedFile,
        file,
        templateData,
        batchName,
        selectedLanguage?.templateId,
        t,
      );
    }
  };

  return (
    <S.StepContent>
      <S.FormContainer>
        <S.StepHeader>
          <S.StepHeaderTitle>
            {t(trans.UPLOAD_DATA_FILE_TITLE.key, trans.UPLOAD_DATA_FILE_TITLE.value)}
          </S.StepHeaderTitle>
          <S.StepSubtitle>
            {t(trans.UPLOAD_DATA_FILE_SUBTITLE.key, trans.UPLOAD_DATA_FILE_SUBTITLE.value)}
          </S.StepSubtitle>
        </S.StepHeader>
        <S.SampleCard>
          <div style={{ display: 'flex', gap: '16px' }}>
            <div
              style={{
                width: '48px',
                height: '48px',
                background: 'linear-gradient(to right, #2563eb, #0891b2)',
                borderRadius: '12px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <Icon type="download" style={{ color: '#fff', fontSize: '24px' }} />
            </div>
            <div style={{ flex: 1 }}>
              <div style={{ fontWeight: '700', color: '#1f2937' }}>
                {t(trans.NEED_TEMPLATE.key, trans.NEED_TEMPLATE.value)}
              </div>
              <p style={{ fontSize: '14px', color: '#4b5563', marginBottom: '12px' }}>
                {t(trans.DOWNLOAD_SAMPLE_DESCRIPTION.key, trans.DOWNLOAD_SAMPLE_DESCRIPTION.value)}
              </p>
              <div style={{ position: 'relative' }}>
                <Button className='standard-batchUpload'
                  style={{
                    height: '36px',
                    borderRadius: '8px',
                    background: 'linear-gradient(to right, #2563eb, #0891b2)',
                  }}
                  type="primary"
                  onClick={() => setShowDownloadDropdown(!showDownloadDropdown)}
                  icon="download"
                >
                  {t(trans.DOWNLOAD_SAMPLE_BUTTON.key, trans.DOWNLOAD_SAMPLE_BUTTON.value)}{' '}
                  <Icon type={showDownloadDropdown ? 'up' : 'down'} />
                </Button>
                {showDownloadDropdown && (
                  <>
                    <div
                      style={{ position: 'fixed', inset: 0, zIndex: 10 }}
                      onClick={() => setShowDownloadDropdown(false)}
                    />
                    <S.DropdownContent style={{ width: '192px', overflow: 'hidden' }}>
                      {[
                        'Excel',
                        'JSON',
                        'XML',
                        'CSV',
                        'TXT (Tab Delimited)',
                        'TXT (Pipe Delimited)',
                      ].map(f => {
                        let formatKey = `FORMAT_${f.toUpperCase()}`;
                        if (f === 'TXT (Tab Delimited)') formatKey = 'FORMAT_TXT_TAB';
                        if (f === 'TXT (Pipe Delimited)') formatKey = 'FORMAT_TXT_PIPE';
                        return (
                          <S.DropdownItem key={f} onClick={() => handleDownloadSample(f)}>
                            <Icon
                              type="download"
                              style={{ color: '#2563eb', marginRight: '10px' }}
                            />
                            <span style={{ fontWeight: '600' }}>
                              {trans[formatKey]
                                ? t(trans[formatKey].key, trans[formatKey].value)
                                : f}
                            </span>
                          </S.DropdownItem>
                        );
                      })}
                    </S.DropdownContent>
                  </>
                )}
              </div>
            </div>
          </div>
        </S.SampleCard>
        {!uploadedFile ? (
          <S.UploadArea>
            <div
              style={{
                width: '64px',
                height: '52px',
                backgroundColor: '#fef9c3',
                borderRadius: '16px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                margin: '0 auto 16px',
              }}
            >
              <Icon type="upload" style={{ fontSize: '32px', color: '#ca8a04' }} />
            </div>
            <div style={{ fontWeight: '600', fontSize: '18px', color: '#1f2937' }}>
              {t(trans.UPLOAD_AREA_TITLE.key, trans.UPLOAD_AREA_TITLE.value)}
            </div>
            <p style={{ fontSize: '14px', color: '#6b7280' }}>
              {t(trans.UPLOAD_AREA_DESCRIPTION.key, trans.UPLOAD_AREA_DESCRIPTION.value)}
            </p>
            <div style={{ display: 'inline-block' }}>
              <input
                type="file"
                ref={fileInputRef}
                onChange={handleFileSelect}
                style={{ display: 'none' }}
              />
              <Upload
                accept=".xls, .xlsx, .json, .xml"
                showUploadList={false}
                className="varUpload-batch"
                style={{paddingTop:'40px',paddingBottom:'24px'}}
                beforeUpload={handleUpload}
                // disabled={userDetails.isTransactionFull}
              >
                <Button
                  size="large"
                  type="primary"
                  className='upload-btn-batch'
                  // onClick={() => fileInputRef.current.click()}
                  style={{
                    display:'flex',
                    alignItems:'center',
                    borderRadius:'10px',
                    padding:'18px',
                    width:'fit-content',
                    backgroundColor: '#ffeb3b',
                    borderColor: '#ffeb3b',
                    color: '#000',
                  }}
                >
                   <Icon type="upload" style={{ fontSize: '18px', color: '#ca8a04' }} />
                  {t(trans.SELECT_FILE_BUTTON.key, trans.SELECT_FILE_BUTTON.value)}
                </Button>
              </Upload>
            </div>
          </S.UploadArea>
        ) : (
          <div
            style={{
              padding: '24px',
              border: '2px solid #ffeb3b',
              borderRadius: '16px',
              backgroundColor: '#fefce8',
            }}
          >
            <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
              <div
                style={{
                  width: '56px',
                  height: '56px',
                  backgroundColor: '#ffeb3b',
                  borderRadius: '16px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                <Icon type="check" style={{ fontSize: '28px' }} />
              </div>
              <div style={{ flex: 1 }}>
                <div style={{ fontWeight: '600', fontSize: '18px', color: 'black' }}>
                  {t(trans.FILE_UPLOADED_SUCCESS.key, trans.FILE_UPLOADED_SUCCESS.value)}
                </div>
                <div style={{ fontSize: '14px', color: 'black' }}>{uploadedFile.name}</div>
              </div>
              <Button
                style={{ color: 'black', backgroundColor: '#FEFCE8' }}
                onClick={() => {
                  setUploadedFile(null);
                  setRequestData();
                }}
              >
                {t(trans.CHANGE_FILE.key, trans.CHANGE_FILE.value)}
              </Button>
            </div>
          </div>
        )}
      </S.FormContainer>
    </S.StepContent>
  );
};

export default withTranslation(NAMESPACES)(Step3DataUpload);
